import { FirebaseConnection, FunctionsRepository, DataCallback } from '../Infrastractures';
import { Function, Functions } from '../Entities/Function';
import { ThreadRepository } from '../Infrastractures/ThreadRepository';
import { Post } from '../Entities/Chat/Post';
import { PostFactory } from '../Entities/Chat/PostFactory';

export class DataUpdateUsecase {
  private _functionsRepository: FunctionsRepository;

  public constructor(private firebaseAdmin:any, private firebaseConnection: FirebaseConnection, private functions:Functions) {
    this._functionsRepository = new FunctionsRepository(firebaseConnection);
  }

  private get functionsRepository(): FunctionsRepository {
    if (!this._functionsRepository) {
      this._functionsRepository = new FunctionsRepository(this.firebaseConnection);
    }
    return this._functionsRepository;
  }

  public async update(dataSaveCallback:any) {
    const functions = this.functions;
    const functionsRepository = this.functionsRepository;
    const self = this;
    this.functions.keys().forEach((key: string) => {
      const func: Function<Post> = functions.get(key);
      const repository = ThreadRepository.getInstance(func, func.id, functionsRepository);

      self.getChildren(dataSaveCallback, repository, func);
    })
  }

  private getChildren(dataSaveCallback:any, repository: ThreadRepository, parent: Function<Post> | Post): void {
    if (!parent.hasChildren()) return;

    const uid = this.firebaseConnection.authUid;
    const self = this;
    const callback = new class implements DataCallback {
      public async setData(id: string, data: any): Promise<boolean> {
        if (!data.contents && !data.user_uids) return false;
        const post = PostFactory.getInstance(id, data);
        
        if (data.hasOwnProperty('user_uids')
          && !data.user_uids.includes(uid)) {
          return false;
        }

        if (! parent.postList.hasKey(id)) {
          dataSaveCallback(parent.postList, post);
          self.functionsRepository.save(self.functions);
        }
        
        return true;
      }
    }();

    const lastUpdate = this.firebaseAdmin.firestore.Timestamp.fromDate(parent.postList.lastUpdate());
    parent.postList.keys().forEach((key: string) => {
      if (!repository.hasChildRepository()) return;
      const childRepository = repository.childRepository(key);

      self.getChildren(dataSaveCallback, childRepository, parent.postList.get(key));
    });

    repository.waitSnapshot(callback, lastUpdate);

    return;
  }
}
